import { SearchApiFacilityExam } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { CartItemBody } from '@/types/cart.types';

export function getUnpricedExams(exams: SearchApiFacilityExam[]): SearchApiFacilityExam[] {
  return exams.filter((exam) => !exam.price);
}

export function buildLaboratoryCartItems(
  exams: SearchApiFacilityExam[],
  patientId: string,
  partnerFacilityId: string,
  slotId: string,
): CartItemBody[] {
  return exams.map((exam) => ({
    procedureId: exam.id,
    patientId,
    partnerFacilityId,
    promotionId: exam.promotion?.id,
    slotId,
  }));
}
